import React from 'react';
import { createRoot } from 'react-dom/client';
import ChatBot from './Kore-chat-bot/components/chat-bot';
import Fonts from './Kore-chat-bot/utils/Fonts';

const container = document.getElementById('kore-chat-bot');
const fontStyles = document.createElement('style');
fontStyles.appendChild(document.createTextNode(Fonts.FontCollection));
document.head.appendChild(fontStyles);
document.body.appendChild(container);
const shadowRoot = container.attachShadow({mode: 'open'});
const root = createRoot(shadowRoot);

root.render(<ChatBot 
            botName={container.dataset['botName']}
            botId={container.dataset['botId']}
            apiRootUrl={container.dataset['apiRootUrl']}
            cssUrl={container.dataset['cssUrl']}
            chatAuthenticated={container.dataset['chatAuthenticated']} />);